<template>
  <transition name="zoom">
    <div
      v-if="open"
      class="fixed z-[2000] top-0 left-0 w-full h-full flex items-center justify-center isolate overscroll-contain"
      @click.self="close(true)"
    >
      <div
        class="absolute top-0 left-0 w-full h-full bg-transparent z-0 backdrop-blur-sm"
        @click="close(true)"
      />
      <dialog
        class="z-10 w-full max-w-xl p-0 bg-white rounded-md shadow-md border border-gray-300 max-h-[90vh] overflow-y-auto flex flex-col isolate dark:bg-gray-800 dark:border-gray-600"
        :class="{
          'max-w-xl max-h-[60%]': size === 'sm',
          'max-w-2xl max-h-[75%]': size === 'md',
          'max-w-screen-lg max-h-[90%]': size === 'lg',
        }"
      >
        <div
          class="flex-none flex flex-row items-center justify-start gap-4 p-5 border-b rounded-t dark:border-gray-600 bg-gradient-to-r from-blue-50 to-blue-100 dark:from-blue-900 dark:to-blue-800 relative"
        >
          <slot name="header">
            <IconComponent
              v-if="icon"
              :icon="icon"
              :pack="iconPack"
              class="w-8 h-8 text-primary"
            />
            <div class="flex flex-col gap-2 items-start">
              <div
                class="text-xl font-semibold text-gray-900 dark:text-gray-100"
              >
                {{ title }}
              </div>
              <div
                v-if="subtitle"
                class="text-sm text-gray-500 dark:text-gray-300"
              >
                {{ subtitle }}
              </div>
            </div>
          </slot>
          <div
            class="absolute top-4 right-4 cursor-pointer"
            @click="close(false)"
          >
            <IconComponent
              class="text-gray-600 dark:text-white m-1 cursor-pointer"
              icon="times"
            />
          </div>
        </div>
        <div class="flex-initial min-h-0 p-5 space-y-6 overflow-auto">
          <slot name="body"> Joszaki body </slot>
        </div>
        <template v-if="!hideFooter">
          <div
            class="flex-none flex items-center space-x-2 border-t border-gray-200 rounded-b dark:border-gray-600 p-5"
          >
            <slot name="footer">
              <JoszakiButton
                type="error"
                class="flex-1"
                @click="$emit('cancel')"
              >
                {{ $t("common.cancel") }}
              </JoszakiButton>
              <JoszakiButton
                type="success"
                class="flex-1"
                :loading="loading"
                :disabled="disableConfirm"
                @click="$emit('confirm')"
              >
                {{ confirmButtonLabel ?? $t("common.accept") }}
              </JoszakiButton>
            </slot>
          </div>
        </template>
      </dialog>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    icon: {
      type: String,
      required: false,
      default: null,
    },
    iconPack: {
      type: String,
      required: false,
      default: "fas",
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
    subtitle: {
      type: String,
      required: false,
      default: "",
    },
    size: {
      type: String,
      default: "md",
      validator: (val) => ["sm", "md", "lg", "full"].includes(val),
    },
    hideFooter: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disableConfirm: {
      type: Boolean,
      default: false,
    },
    confirmButtonLabel: {
      type: String,
      default: null,
    },
  },
  watch: {
    open: {
      immediate: true,
      handler(val) {
        if (process.server) {
          return;
        }
        if (val) {
          document.addEventListener("keydown", this.escapeListener);
        } else {
          document.removeEventListener("keydown", this.escapeListener);
        }
      },
    },
  },
  methods: {
    escapeListener(evt) {
      if (evt?.key === "Escape") {
        this.close(false);
      }
    },
    close(isOutsideClick = false) {
      this.$emit("close", isOutsideClick);
    },
  },
};
</script>

<style lang="scss" scoped>
.zoom-enter-active,
.zoom-leave-active {
  transition: all 0.2s ease;
}
.zoom-enter,
.zoom-leave-to {
  transform: scale(0, 0);
}
</style>
